define('context/user',['require','backbone'],function(require){

	var Backbone = require('backbone');

	var User = Backbone.Model.extend({

	});

    return User;

});
